import Image from "next/image";
import { motion, AnimatePresence } from "framer-motion";
import { ClassProp, ProjectProps } from "./Props";
import CLink from "../../../_reusables/CLink";
import { useProjectsList } from "../../../../contexts/ProjectsListContext";

const verticalMiddleLine = {
	hidden: {
		opacity: 0,
		scale: 0,
	},
	visible: {
		opacity: 1,
		scale: 1,
		transition: { duration: 1 },
	},
};

const horizontalMiddleLine = {
	hidden: {
		opacity: 0,
		scale: 0,
	},
	visible: {
		opacity: 1,
		scale: 1,
		transition: { duration: 0.7 },
	},
	exit: {
		opacity: 1,
		scale: 1,
		transition: { duration: 0.7 },
	},
};

const anim = {
	hidden: {
		opacity: 0,
		scale: 0,
	},
	visible: {
		opacity: 1,
		scale: 1,
		transition: { duration: 1 },
	},
	exit: {
		opacity: 0,
		scale: 0,
	},
};

const ProjectsCards = () => {
	const { filteredProjects } = useProjectsList();

	// console.log(filteredProjects);

	return (
		<div>
			<motion.div
				className="middle-line"
				variants={verticalMiddleLine}
				initial="hidden"
				animate="visible"
			></motion.div>

			<motion.ul className="projects-cards" layout>
				{filteredProjects.map((project) => {
					// if (project.publish) {
					if (!project.needs_attention) {
						return (
							<ProjectCard key={project.id} project={project} />
						);
					}
				})}
			</motion.ul>
		</div>
	);
};

type ProjectCardProps = ClassProp & {
	project: ProjectProps;
};

// const ProjectCard = ({ project }: ProjectCardProps) => {
const ProjectCard = ({ project }: any) => {
	// const {
	// 	id,
	// 	image: { src, alt },
	// 	title,
	// 	links,
	// 	tools,
	// 	bgPosition,
	// } = project;

	// const stopPulsating = (currentTitle, leave?: boolean) => {
	// 	const allProjectCard = document.querySelectorAll(".project-card");

	// 	allProjectCard.forEach((card) => {
	// 		if (card.id != currentTitle) {
	// 			if (leave) {
	// 				card.classList.remove("test");
	// 			} else {
	// 				card.classList.add("test");
	// 			}
	// 		}
	// 	});
	// };

	return (
		<motion.li className="project-card-wrapper">
			<motion.div
				className="bottom-line"
				variants={horizontalMiddleLine}
				initial="hidden"
				whileInView="visible"
				// exit="exit"
				viewport={{ once: true }}
			></motion.div>

			{/* <AnimatePresence key={project?.id}> */}
			<motion.div
				className="project-card "
				id={`${project?.id}`}
				// drag
				variants={anim}
				initial="hidden"
				whileInView="visible"
				exit="exit"
				// onMouseEnter={() => {
				// 	stopPulsating(`${id}`);
				// }}
				// onMouseLeave={(e) => {
				// 	stopPulsating(`${id}`, true);
				// }}
			>
				<CLink
					href={
						project?.title?.toLowerCase()?.includes("thecopydev")
							? "#"
							: project?.demo_url
					}
					className="project-link "
					external={
						!project?.title?.toLowerCase()?.includes("thecopydev")
					}
				>
					<div className="image-bg">
						<div className="image-container">
							<Image
								src={
									project?.banner
										? `https://drive.google.com/uc?id=${project?.banner}`
										: "https://drive.google.com/uc?id=1DHWBhYGj2_josuqvSrfnBgcVmXx8KNYl"
								}
								alt={project?.alt ?? "project banner"}
								layout="fill"
								// style={{
								// 	objectFit: "100% cover",
								// }}
								objectFit="cover"
								objectPosition={project?.bgPosition}
							/>
						</div>
					</div>

					<div className="project-details">
						<p>
							{project?.tech_stack_details
								?.map((tool: any) => tool?.name)
								?.join(" - ")}
						</p>
						<p className="title  w-fit">{project?.title}</p>
					</div>
				</CLink>
			</motion.div>
			{/* </AnimatePresence> */}
		</motion.li>
	);
};

export default ProjectsCards;
